<script setup>
import { ref, computed, defineProps, watch, watchEffect } from 'vue';
import InfoBoxBottom from '@/components/cloudCounter/InfoBoxBottom.vue';

const props = defineProps({
    selectOptions: Object,
    changeHandel: Function,
});

// console.log('object');

/*
    selectOptions : {
        selectValue
        placeholder
        boxData :{
            boxTitle: '請選擇視訊時間',
            options:
            [
                '09:00 - 10:00',
                '09:30 - 10:30',
                '10:00 - 11:00',
                '10:30 - 11:30',
                '11:00 - 12:00',
                '13:00 - 14:00',
            ]
        }
    }
*/

const infoBoxVisible = ref(false);

const openOptions = (e) => {
    if (props.selectOptions?.boxData?.options?.length > 1) {
        infoBoxVisible.value = true;
    }
};

const setValue = (option) => {
    const _value = (typeof option === 'string') ? option : option.value;

    if (typeof props.selectOptions.setValue === 'function') {
        props.selectOptions.setValue(_value);
    }

    if (typeof props.changeHandel === 'function') {
        props.changeHandel();
    }

    props.selectOptions.selectValue = _value;
    infoBoxVisible.value = false;
};




const selectedindex = computed(() => {

    const _selectValue = props.selectOptions.selectValue;
    const _options = props.selectOptions.boxData?.options;
    let _index = 0;

    if (_options) {
        for (let i = 0; i < _options.length; i++) {
            const element = _options[i];
            if ((typeof element === 'string' && element === _selectValue) || (element?.value === _selectValue)) {
                _index = i;
                break;
            }
        }
    }

    return _index;

});






</script>

<template>

    <div class="flex justify-between p-3 w-full border rounded-md cursor-pointer bg-white" @click="openOptions"
        v-if="selectOptions">
        <div class="flex-1">
            <template v-if="selectOptions.selectValue">

                <template v-if="typeof selectOptions.boxData?.options[0] === 'string'">
                    {{ selectOptions.selectValue }}
                </template>
                <template v-else>
                    <div class="flex">
                        <div class="pr-3" v-html="selectOptions.boxData?.options[selectedindex]?.leftContent"></div>
                        <div>{{ selectOptions.selectValue }}</div>
                    </div>
                </template>

            </template>
            <template class="text-[]" v-else>{{ selectOptions.placeholder || '-' }}</template>
        </div>
        <div v-if="selectOptions.boxData?.options?.length > 1">
            <svg fill="#0093C1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                style="width: 24px; height: 24px;">
                <title>chevron-down</title>
                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
            </svg>
        </div>
    </div>

    <InfoBoxBottom :visible="infoBoxVisible" :boxTitle="selectOptions.boxData?.boxTitle"
        :closeHandle="(e) => { infoBoxVisible = false; }">
        <ul>
            <li v-for="(option, i) in selectOptions.boxData?.options" :key="i"
                :class="{ 'border-t border-[#DADADA]': i !== 0 }">
                <button class="w-full py-4 text-left cursor-pointer" @click="(e) => { setValue(option); }">
                    <template v-if="typeof option === 'string'">{{ option }}</template>
                    <template v-else>
                        <div class="flex items-center">
                            <div class="pr-3" v-if="option.leftContent" v-html="option.leftContent"></div>
                            <div>{{ option.value }}</div>
                            <div class="pl-3" v-if="option.rightContent" v-html="option.rightContent"></div>
                        </div>
                    </template>
                </button>
            </li>
        </ul>
    </InfoBoxBottom>

</template>

<style scoped></style>
